import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IFavoriteDepartureFields } from "../../../../Orchestrator/Types/Types/OffersResponse";

interface IUpdatePersonalizeFavoriteDepartureFieldValueParams {
    fieldName: string, favoriteDeparture: IFavoriteDepartureFields[], value: string, valueLabel: string, valueCode: string
}

class UpdatePersonalizeFavoriteDepartureFieldValueAction extends BaseAction<void, IUpdatePersonalizeFavoriteDepartureFieldValueParams> {
    override async run(): Promise<void> {
        try {
            const { fieldName, favoriteDeparture, value, valueLabel, valueCode } = this.params!;
            const newFavoriteDeparture = favoriteDeparture.map(departure => {
                const newDeparture = { ...departure };
                if (departure.name === fieldName) {
                    newDeparture.value = value;
                    newDeparture.valueLabel = valueLabel;
                    newDeparture.valueCode = valueCode;
                }
                return newDeparture;
            }
            );
            updateRecoilState("favoriteDepartureFieldsAtom", newFavoriteDeparture);
        } catch (error: any) {
            console.log("Error updatePersonalizeFavoriteDepartureFieldValue", error?.message);
        }
    }
}

export const updatePersonalizeFavoriteDepartureFieldValueAction = new UpdatePersonalizeFavoriteDepartureFieldValueAction();
